import { Route, Redirect } from "react-router-dom"

function PrivateRoute({ children, ...rest }) {
  const isAuthenticated = window.localStorage.getItem("authToken")

  return (
    <Route
      {...rest}
      render={({ location }) => {
        return isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }}
    />
  )
}

export default PrivateRoute
